module.exports = __webpack_public_path__ + "img/class9.2e6e5959.png";